module.exports = __webpack_public_path__ + "img/dh4.fe481a24.jpg";